module.exports = __webpack_public_path__ + "static/media/clock.c18e664a.svg";